import { Component, Optional, Inject, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, } from '@angular/forms';
import { ElementBase } from 'src/app/core/form/element-base';
import { DatepickerDirective } from 'src/app/core/directives/datepicker.directive';
import * as moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: DatepickerComponent, multi: true }
  ],
})
export class DatepickerComponent extends ElementBase<any> implements OnChanges {
  @Input() public label: string;
  @Input() public placeholder: string = 'Fecha ida';
  @Input() public placeholder2: string = 'Fecha vuelta';
  @Input() public options = {};
  @Input() multiDest = false;
  @Input() public singleDate = false;
  @Input() public mobileMode = false;
  @Input() public mobileViewMode = '1';
  @Input() public submit: boolean;
  datepickerOptions = {};

  @ViewChild(DatepickerDirective) datepickerInput: DatepickerDirective;
  @ViewChild(NgModel) model: NgModel;
  set datepickerValue(value) {
    this.value = value;
    this.setData(value);
  }

  get datepickerValue() {
    return this.value;
  }

  public date1 = {
    numDay: '',
    nameDay: '',
    monthYear: '',
    monthDay: ''
  };
  public date2 = {
    numDay: '',
    nameDay: '',
    monthYear: '',
    monthDay: ''
  };
  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.singleDate && changes.singleDate.currentValue) || this.singleDate) {
      this.datepickerOptions = {
        ...this.options,
        ...{ singleDate: true }
      };
    } else {
      this.datepickerOptions = {
        ...this.options,
        ...{ singleDate: false }
      };
    }
  }

  openDatepicker(evt = null) {
    setTimeout(() => {
      this.datepickerInput.open(evt);
    }, 100);
  }

  setData(value) {
    moment.locale('es');
    if (value && value.length > 0) {
      value.forEach((date, i) => {
        let mDate = moment(date, 'DD-MM-YYYY');
        this['date' + (i + 1)] = {
          numDay: mDate.format('DD'),
          nameDay: mDate.format('dddd'),
          monthYear: mDate.format('MMMM YYYY'),
          monthDay: mDate.format('MMM DD')
        }
      });
      if (value.length == 1) {
        this.resetDate(2);
      }
    } else {
      this.resetDate(1);
      this.resetDate(2);
    }
  }

  resetDate(num) {
    this['date' + num] = {
      numDay: '',
      nameDay: '',
      monthYear: '',
      monthDay: ''
    };
  }
}
